import type { FaireProductEntity } from "../../entity_types/product";

export const p_aaf4gjn32d: FaireProductEntity = {
  token: "p_aaf4gjn32d",
  type: "product",
  name: "NOVELTY MACRAME CROPPED JACKET",
  brandToken: "b_22tswwgnqb",
  brandName: "Emory Park",
  imageUrl:
    "https://cdn.faire.com/fastly/d54ce57853ed211e54822f801cae42ef9b555ea05b1e39a2bd6ca0530ade8826.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/150966310bc9b147c8a288acc4450ba7c5d5e2d404970a5087991e4cb5d04668.jpeg",
    "https://cdn.faire.com/fastly/450041d660a9f085ce85322d743a230f9fffb44c1bba4c819e43b980c742f0fe.jpeg",
    "https://cdn.faire.com/fastly/11d3311798f5b3917c85fd3d6875eee2a730f4a4e0f676a1705367ea78d2b6dc.jpeg",
    "https://cdn.faire.com/fastly/169cdc50d41ada4b98e58da7863e3d7e2b27ceda413907645f2f9f15f0328a0c.jpeg",
    "https://cdn.faire.com/fastly/4f2ac3e59512467c98bb8619a03310293c2e1e2be24cb871538736b1dae38d64.jpeg",
    "https://cdn.faire.com/fastly/c136596df44595fb8652ba04a52661753547bf05868a898c7c12bdcae4f6338f.jpeg",
    "https://cdn.faire.com/fastly/d459bfa20774e358db56f8aa8af3ef512035f507366467995b7f5993068ec26b.jpeg",
    "https://cdn.faire.com/fastly/e9d3e7a2443d413ed8897e911788d0bf70f34da84763685f5d1a5c8c240e72c7.jpeg",
    "https://cdn.faire.com/fastly/e6bb2831f9e77507af7bc7db0f632bd3cccd17bc371d89c9538c11571b752d46.jpeg",
  ],
  priceDollars: 274.37,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 548.73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:36.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
